<div mat-dialog-content>

    <kt-filter-editor  
     [lotteryId]="data.lotteryId"  
     [cols]="data.cols" [rows]="data.rows" 
     [numberList]="data.numberList" 
     [filter]="data.filter"
     (changeParams) = "changeParams($event)"
     [showSaveButton] = "false"
     [betId]="data.betId"
     >
    </kt-filter-editor>

</div>


<div mat-dialog-actions align="end">

    <button mat-button (click)="confirm()">Confirmar</button>&nbsp;
    <button mat-button (click)="onNoClick()">Cancelar</button>

</div>